/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var moyaFetch = MoyaContainer.get('core.fetch');
    var OverlayClass = MoyaContainer.get('core.overlay').OverlayClass;
    MoyaComponents.register('extras.gamesearch', function (el) {
        var gameSearchConfig = {
            rowWrap: el.querySelector('.game__view'),
            form: el.querySelector('.moya_form'),
            noResultsMessage: el.dataset.noResultsMessage
        };
        GameSearch.create(gameSearchConfig);
    });
    var OverlayStyle;
    (function (OverlayStyle) {
        OverlayStyle["DARK"] = "dark";
        OverlayStyle["LIGHT"] = "light";
    })(OverlayStyle || (OverlayStyle = {}));
    var GameSearch = /** @class */ (function () {
        function GameSearch(config) {
            this.form = config.form;
            this.rowWrap = config.rowWrap;
            this.noResultsMessage = config.noResultsMessage;
        }
        GameSearch.create = function (config) {
            return new GameSearch(config).run();
        };
        GameSearch.prototype.run = function () {
            this.fixForm();
            this.handleSubmit();
            this.bindInput();
        };
        GameSearch.prototype.handleSubmit = function () {
            var _this = this;
            this.form.addEventListener('submit', function (e) {
                e.preventDefault();
                var overlay = new OverlayClass(_this.form, { style: OverlayStyle.LIGHT });
                overlay.show('spinner');
                moyaFetch.fetchJson(_this.form.action, 'POST', new FormData(_this.form))
                    .then(function (res) {
                    var promise = new Promise(function (resolve) {
                        setTimeout(function () {
                            for (var i = 0; i < _this.rowWrap.children.length; i++) {
                                _this.rowWrap.children[i].classList.add('scale-out-center');
                            }
                            resolve();
                        }, 400);
                    });
                    Promise.all([promise]).then(function () {
                        if (res.success) {
                            _this.rowWrap.innerHTML = res.results.toString();
                            site.game.init();
                        }
                        else {
                            _this.rowWrap.innerHTML = _this.noResultsMessage;
                        }
                    });
                }).finally(function () {
                    setTimeout(function () {
                        overlay.hide();
                    }, 400);
                });
            });
        };
        GameSearch.prototype.fixForm = function () {
            this.form.querySelectorAll('label').forEach(function (el) {
                el.classList.add('sr-only');
            });
        };
        GameSearch.prototype.bindInput = function () {
            var _this = this;
            util.delegate(this.form.querySelector('input.text'), 'keyup', 'input.text', function (e) {
                var input = e.delegateTarget;
                clearTimeout(_this.timeout);
                if (input.value !== _this.currentInput) {
                    _this.timeout = setTimeout(function () {
                        _this.currentInput = input.value;
                        _this.triggerSubmit(e);
                    }, 400);
                }
            });
        };
        GameSearch.prototype.triggerSubmit = function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                return false;
            }
            else {
                this.form.dispatchEvent(new Event('submit', { cancelable: true }));
            }
        };
        return GameSearch;
    }());

    exports.GameSearch = GameSearch;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
